import { render, staticRenderFns } from "./addLink.vue?vue&type=template&id=9316295e&scoped=true&"
import script from "./addLink.vue?vue&type=script&lang=js&"
export * from "./addLink.vue?vue&type=script&lang=js&"
import style0 from "./addLink.vue?vue&type=style&index=0&id=9316295e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9316295e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\demoAdmin\\chuangyueBlockchaimAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9316295e')) {
      api.createRecord('9316295e', component.options)
    } else {
      api.reload('9316295e', component.options)
    }
    module.hot.accept("./addLink.vue?vue&type=template&id=9316295e&scoped=true&", function () {
      api.rerender('9316295e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/currency/bourse/components/addLink.vue"
export default component.exports